import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {CommentCreate} from '../../shared/models/comment.model';
import {FormControl, FormGroup} from '@angular/forms';
import {DataStorageService} from '../../shared/services/data-storage.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-form-date-route-comment',
    templateUrl: './form-date-route-comment.component.html',
    styleUrls: ['./form-date-route-comment.component.css']
})
export class FormDateRouteCommentComponent implements OnInit, OnDestroy {

    @Input() date: string;
    @Input() route_id: number;
    @Input() user_id: number;
    commentForm: FormGroup;

    private unsubscribe$: Subject<void> = new Subject<void>();

    constructor(private dataStorageService: DataStorageService) {
    }

    ngOnInit() {
        this.initForm();
    }

    initForm() {
        this.commentForm = new FormGroup({
            'comment': new FormControl()
        });
    }

    onSubmit() {
        const commentCreate = new CommentCreate(this.commentForm.get('comment').value, this.user_id);
        commentCreate.date = this.date;
        commentCreate.route_id = this.route_id;
        this.dataStorageService.createCommentDateRoute(commentCreate).pipe(takeUntil(this.unsubscribe$)).subscribe(
            responseData => {
                if (responseData['error']) {
                    console.log('saving comment error');
                } else {
                    alert('comment added. ');
                    location.reload();
                }
            }
        );
    }

    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

}
